<script setup lang="ts">
const mediaStore = useMediaPlayerStore();

const mediaType = computed(() =>
  mediaStore.nowPlaying?.type === "video" ? "video" : "song",
);
</script>

<template>
  <div class="now-playing">
    <div
      class="album"
      :class="{ 'album-video': mediaType === 'video' }"
    >
      <AlbumArtwork
        :media-type="mediaType"
        :url="mediaStore.nowPlaying?.artwork ?? ''"
        :restrict-width="80"
      />
    </div>
    <div class="now-playing-text">
      <div
        class="title"
        :title="mediaStore.nowPlaying?.title"
        :class="{ 'asian-text': hasAsianText(mediaStore.nowPlaying?.title) }"
      >
        {{ mediaStore.nowPlaying?.title ?? "" }}
      </div>
      <div
        class="subtitle"
        :title="mediaStore.nowPlaying?.subtitle"
      >
        {{ mediaStore.nowPlaying?.subtitle ?? "" }}
      </div>
    </div>
  </div>
</template>

<style scoped lang="postcss">
.album {
  @apply h-16 w-16 sm:h-20 sm:w-20;
}
.now-playing {
  @apply flex items-center gap-3 text-white;
}
.title {
  @apply line-clamp-2 text-lg leading-5;
  &:not(.asian-text) {
    padding-bottom: 0.14em;
  }
}
.subtitle {
  @apply leading-5 text-gray-200;
}
</style>
